module.exports = __webpack_public_path__ + "static/img/11bg_11.30b0ac8.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/11bg_11.png
// module id = 619
// module chunks = 1